"use client";
import React, { useEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./FintechSolutionsSection.css";
import BlueSectionDivider from "./BlueSectionDivider";
import {Link} from 'react-router-dom';

const stats = [
  { value: "+90", label: "Specialists" },
  { value: "+20", label: "Industry sectors" },
  { value: "78", label: "Customer NPS Score" },
  { value: "99%", label: "Recommendation Rate" },
  { value: "+300", label: "Projects delivered" }
];

const cards = [
  {
    icon: <img src="/icons/banking.webp" alt="Digital Banking" />,
    title: "DIGITAL BANKING",
    desc: "Revolutionize traditional banking with secure and user-friendly digital platforms, offering seamless transactions, mobile banking, and personalized financial management."
  },
  {
    icon: <img src="/icons/payment.webp" alt="Payment and Transaction" />,
    title: "PAYMENT AND TRANSACTION",
    desc: "Enable frictionless transactions and enhance payment experiences with cutting-edge payment gateways, digital wallets, and real-time transaction processing."
  },
  {
    icon: <img src="/icons/wealth.webp" alt="Wealth Management" />,
    title: "WEALTH MANAGEMENT",
    desc: "Transform wealth management with AI-driven robo-advisors, providing personalized investment strategies, portfolio management, and financial planning."
  },
  {
    icon: <img src="/icons/insurtech.webp" alt="Insurtech Innovations" />,
    title: "INSURTECH INNOVATIONS",
    desc: "Optimize insurance processes with Insurtech solutions, offering automated claims processing, risk assessment, and personalized insurance products."
  },
  {
    icon: <img src="/icons/regtech.webp" alt="Regtech" />,
    title: "REGTECH",
    desc: "Stay ahead of regulatory requirements with RegTech solutions, ensuring compliance, data security, and fraud prevention in a rapidly evolving financial landscape."
  }
];

export default function FintechSolutionsSection() {
  const [active, setActive] = useState("solutions");

  // Match MobileSolution structure
  const sectionsToHighlight = [
    "solutions",
    
    "benefits",
    
    "tech-stack",
    "faq",
    "contact-us"
  ];

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const mobileSolutionsNavbarHeight = 60;
      const scrollPosition = window.scrollY + mobileSolutionsNavbarHeight + 20;

      for (let i = sectionsToHighlight.length - 1; i >= 0; i--) {
        const section = document.getElementById(sectionsToHighlight[i]);
        if (section && section.offsetTop <= scrollPosition) {
          const activeLink =
            sectionsToHighlight[i] === "solutions"
              ? "solutions"
              : sectionsToHighlight[i];
          setActive(activeLink);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // run once initially

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = (id) => {
    const sectionId = id === "solutions" ? "solutions" : id;
    setActive(id);
    document.getElementById(sectionId)?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };

  return (
    <>
      {/* Exact same NAVBAR from MobileSolution */}
      <div className="mobile-solutions-navbar">
        <div className="container">
        <ul>
          {["solutions",  "benefits",  "tech stack", "faq", "contact us"].map((item) => (
            <li key={item}>
              <a
                onClick={() => handleClick(item)}
                className={active === item ? "active" : ""}
              >
                {item.toUpperCase()}
              </a>
            </li>
          ))}
        </ul>
        </div>
      </div>

      {/* Your existing Fintech content below remains untouched */}
      <section className="fintech-section" id="solutions">
        <div className="container">
        <div className="fintech-stats-row" data-aos="fade-up">
          {stats.map((stat, i) => (
            <div className="fintech-stat" key={i}>
              <div className="fintech-stat-value">{stat.value}</div>
              <div className="fintech-stat-label">{stat.label}</div>
            </div>
          ))}
          <BlueSectionDivider />
        </div>

        <div className="fintech-title-group" data-aos="fade-up">
          <div className="fintech-title8989">DIGITAL SOLUTIONS</div>
          <div className="fintech-title-blue8989">FOR THE DIFFERENT FINTECH AREAS</div>
        </div>

        <div className="fintech-cards-grid">
          {cards.map((card, i) => (
            <div
              className="fintech-card"
              key={i}
              data-aos="fade-up"
              data-aos-delay={100 + i * 100}
            >
              <div className="fintech-card-icon">{card.icon}</div>
              <div className="fintech-card-title">{card.title}</div>
              <div className="fintech-card-desc">{card.desc}</div>
            </div>
          ))}
        </div>

        <div className="fintech-cta-row" data-aos="fade-up" data-aos-delay="600">
          <button className="fintech-cta-btn">
            <Link to="/contact">
            GET STARTED WITH YOUR FINTECH DIGITAL PRODUCT
            </Link>
          </button>
        </div>
        </div>
      </section>

      {/* Add other placeholder sections if needed for navbar scroll test */}
      {/* <section id="process" style={{ height: "600px", background: "#f8f8f8" }}><h2>PROCESS</h2></section> */}
    </>
  );
}
